import invariant from "tiny-invariant";

import { isUser } from "~/common/user-shape";
import { selectUser } from "~/slices/user";
import { useAppSelector } from "~/store";
import type { TUser } from "~/types/user";

export { isUser } from "~/common/user-shape";

export function useRequiredUser(): TUser {
  const user = useAppSelector(selectUser);
  invariant(isUser(user), "expected user object to be in store");
  return user;
}

export function useOptionalUser(): TUser | null {
  const user = useAppSelector(selectUser);
  return isUser(user) ? user : null;
}

export function canOrderTestPlastic(maybeUser: Partial<TUser>): boolean {
  return maybeUser.privileges?.test_plastic == 1;
}

export function assertIsUser(value: unknown): asserts value is TUser {
  invariant(isUser(value), "value is not a valid user object");
}
